import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { keys } from './frameCompany.key';

export function useGetAllFrameCompanies(
  clientId: string,
  take: number,
  skip: number
) {
  const getApi = useApi();

  const getFrameCompanies = async () => {
    const api = await getApi();
    const res = await api.frameCompanyFindSpecific(clientId, take, skip);
    return res;
  };

  const query = useQuery({
    queryKey: keys.findAll(take, skip),
    queryFn: getFrameCompanies,
  });

  return {
    ...query,
    data: query.data?.data,
    count: query.data?.headers['x-total-count'],
  };
}
